import {
  SET_DOCUMENT_SELECTION_DATA,
  REMOVE_DOCUMENT_SELECTION_DATA,
  CLEAR_DOCUMENT_SELECTION_DATA
} from '.';
import {
  SetSelectedDocumentPayloadParams,
  SetSelectedDocumentAction,
  RemoveSelectedDocumentAction,
  ClearSelectedDocumentAction,
  ClearSelectedDocumentPayloadParams
} from '../mappers/SelectedDocumentTypesMapper';

export const setSelectedDocument = (
  dispatch: (action: SetSelectedDocumentAction) => void,
  params: SetSelectedDocumentPayloadParams
): void => {
  dispatch({
    type: SET_DOCUMENT_SELECTION_DATA,
    payload: params
  });
};

export const removeSelectedDocument = (
  dispatch: (action: RemoveSelectedDocumentAction) => void,
  params: SetSelectedDocumentPayloadParams
): void => {
  dispatch({
    type: REMOVE_DOCUMENT_SELECTION_DATA,
    payload: params
  });
};

export const clearSelectedDocument = (
  dispatch: (action: ClearSelectedDocumentAction) => void,
  params: ClearSelectedDocumentPayloadParams
): void => {
  dispatch({
    type: CLEAR_DOCUMENT_SELECTION_DATA,
    payload: params
  });
};
